// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAACRJREFUKFNjPHTo0H8GJGBnZ8eIzGekgwJk+0BsdCtRHEQbBQBbbh0dIGKknQAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-color-picker-swatches {
  overflow-y: auto;
}
:where(.vuetify-styles) .v-color-picker-swatches > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 8px;
}

:where(.vuetify-styles) .v-color-picker-swatches__swatch {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

:where(.vuetify-styles) .v-color-picker-swatches__color {
  position: relative;
  height: 18px;
  max-height: 18px;
  width: 45px;
  margin: 2px 4px;
  border-radius: 2px;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat;
  cursor: pointer;
}
:where(.vuetify-styles) .v-color-picker-swatches__color--disabled {
  opacity: var(--v-disabled-opacity);
  pointer-events: none;
}
:where(.vuetify-styles) .v-color-picker-swatches__color > div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-color-picker-swatches > div {
    forced-color-adjust: preserve-parent-color;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VColorPicker/VColorPickerSwatches.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,0DAA8L;EAC9L,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,0CAA0C;EAC5C;AACF","sourcesContent":[".v-color-picker-swatches {\n  overflow-y: auto;\n}\n.v-color-picker-swatches > div {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 8px;\n}\n\n.v-color-picker-swatches__swatch {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n}\n\n.v-color-picker-swatches__color {\n  position: relative;\n  height: 18px;\n  max-height: 18px;\n  width: 45px;\n  margin: 2px 4px;\n  border-radius: 2px;\n  user-select: none;\n  overflow: hidden;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAACRJREFUKFNjPHTo0H8GJGBnZ8eIzGekgwJk+0BsdCtRHEQbBQBbbh0dIGKknQAAAABJRU5ErkJggg==) repeat;\n  cursor: pointer;\n}\n.v-color-picker-swatches__color--disabled {\n  opacity: var(--v-disabled-opacity);\n  pointer-events: none;\n}\n.v-color-picker-swatches__color > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n@media (forced-colors: active) {\n  .v-color-picker-swatches > div {\n    forced-color-adjust: preserve-parent-color;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
